export default __webpack_public_path__ + "static/media/calender.1dc13b8f.svg";